import React from 'react';

import { useTranslation } from '@lt/localization';
import { getIsFeatureHasAnOption } from 'src/utils/featureToggle';
import styled from 'styled-components';
import Icon from '../../../../components/Icon';

import { EXTRAS } from '../../store/constants/extras';
import PackageBlockItem from './components/PackageInfoItem';
import PackageRoomInfoContainer from './PackageRoomInfo';
import PackageMealInfoContainer from './components/PackageMealInfo';
import PackageFlightInfoContainer from './PackageFlightInfo';
import PackageTransferInfoContainer from './PackageTransferInfo';
import PackageMedInsuranceInfoContainer from './PackageMedInsuranceInfo';

import PackageInfoSkeleton from './PackageInfoSkeleton';
import type { IPackageInfoBlock } from './types';

const PackageInfoBlock = ({
  mandatoryExtras,
  hasAdjustParams,
  isArchived,
  meal,
  mealCode,
  mealOriginal,
  operatorId,
  isMobile,
}: IPackageInfoBlock): JSX.Element => {
  const { t } = useTranslation();

  const hasWorseExtas = getIsFeatureHasAnOption('ab_worse_extras', 'on');

  return (
    <StyledSection isMobile={isMobile}>
      {hasAdjustParams ? (
        <PackageInfoSkeleton />
      ) : (
        <>
          <StyledTitle isMobile={isMobile}>
            {t('checkout.packageInfo.room.title_package')}
          </StyledTitle>
          <StyledBlock>
            <PackageRoomInfoContainer />
            <PackageMealInfoContainer
              meal={meal}
              mealCode={mealCode}
              mealOriginal={mealOriginal}
              operatorId={operatorId}
              isMobile={isMobile}
            />
            <PackageFlightInfoContainer isArchived={isArchived} />
            {!hasWorseExtas && (
              <>
                <PackageTransferInfoContainer />
                <PackageMedInsuranceInfoContainer />
                {mandatoryExtras.map(({ code_name: id, name: title }) => (
                  <PackageBlockItem
                    key={id}
                    icon={
                      id === EXTRAS.NEW_YEAR_DINNER ||
                      id === EXTRAS.CHRISTMAS_DINNER ? (
                        <Icon type="food" />
                      ) : undefined
                    }
                    text={`${title} (${t('checkout.billInfo.mandatory')})`}
                    isMobile={isMobile}
                  />
                ))}
              </>
            )}
          </StyledBlock>
        </>
      )}
    </StyledSection>
  );
};

const StyledSection = styled.section<{ isMobile: boolean }>`
  min-height: 30px;
  box-sizing: border-box;
  ${({ isMobile }) => isMobile && `padding-left: 0;`}
`;

const StyledTitle = styled.h2<{ isMobile: boolean }>`
  padding-left: ${({ isMobile }) => (isMobile ? 0 : 18)}px;
  padding-top: 3px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #17181a;
`;

const StyledBlock = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export default PackageInfoBlock;
